export default __webpack_public_path__ + "static/media/haxe.10a910ff.svg";